import { FC, JSX } from 'react';
import { clsx } from 'clsx';
import { IMappedGroupSchedule, IMappedTeacherSchedule } from 'entities/types';

import { extractDay } from '../lib';
import { ICardScheduleProps } from '../models/ICardScheduleProps';

import styles from './styles.module.scss';

interface ICardRowProps {
  data: IMappedGroupSchedule | IMappedTeacherSchedule;
}
const CardRow: FC<ICardRowProps> = ({ data }) => {
  return (
    <div
      className={clsx(
        styles['calendar-schedule__lesson'],
        {
          [styles['calendar-schedule__lesson_blue']]:
            data.disciplType === 'Лабораторная работа',
        },
        {
          [styles['calendar-schedule__lesson_violet']]:
            data.disciplType === 'Практика',
        },
        {
          [styles['calendar-schedule__lesson_red']]:
            data.disciplType === 'Лекция',
        },
      )}
    >
      {data.disciplTime} — {data.disciplName}
    </div>
  );
};

export const CardSchedule: FC<ICardScheduleProps> = ({
  isNotThisMonth,
  isWeekend,
  dataDate,
  dataSchedule,
  onClick,
}) => {
  let mappedDataSchedule: JSX.Element[];

  if (dataSchedule.length > 4) {
    mappedDataSchedule = dataSchedule.slice(0, 3).map((item, index) => {
      return <CardRow data={item} key={index} />;
    });
    mappedDataSchedule.push(
      <div className={styles['calendar-schedule__more-label']}>
        Еще {dataSchedule.length - 3}
      </div>,
    );
  } else {
    mappedDataSchedule = dataSchedule.map((item, index) => {
      return <CardRow data={item} key={index} />;
    });
  }

  return (
    <div
      className={clsx(styles['calendar-schedule__card'])}
      onClick={(e) => onClick(e, dataSchedule, dataDate)}
    >
      {isWeekend && (
        <div
          style={{
            position: 'absolute',
            background: 'var(--green-light-5)',
            width: '100%',
            height: '100%',
          }}
        ></div>
      )}
      {isNotThisMonth && !isWeekend && (
        <div
          style={{
            position: 'absolute',
            background: 'var(--gray-light-8)',
            width: '100%',
            height: '100%',
          }}
        ></div>
      )}
      <div
        className={clsx(styles['calendar-schedule__date'], {
          [styles['calendar-schedule__date_gray']]: isNotThisMonth,
        })}
      >
        <div className={styles['calendar-schedule__date-left']}>
          {dataDate.weekParity}
          <br />
          {dataDate.timeInterval}
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-day'], {
            [styles['calendar-schedule__date-day_primary']]: dataDate.isPrimary,
          })}
        >
          {extractDay(dataDate.date)}
        </div>
      </div>
      <div
        className={clsx(styles['calendar-schedule__lessons'], {
          [styles['calendar-schedule__lessons_gray']]: isNotThisMonth,
        })}
      >
        {mappedDataSchedule}
      </div>
    </div>
  );
};
